import React, { useContext, useState } from "react";
import {
  Drawer,
  Button,
  CircularProgress,
  InputAdornment,
  Input,
} from "@material-ui/core";
import { Instance } from "../Config";
import GlobalContext from "../Context/globalContext";
import { SHOW_SNACKBAR, SIGN_IN } from "../Context/globalActions.types";
import { useParams, useHistory, useLocation } from "react-router-dom";
import PermIdentityOutlinedIcon from "@material-ui/icons/PermIdentityOutlined";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";

export default function LoginDrawer() {
  const [state, setState] = React.useState({
    bottom: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const [isUserNameValid, setIsUserNameValid] = useState(true);
  const [isPasswordValid, setIsPasswordValid] = useState(true);

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");

  const params = useParams();
  const history = useHistory();
  let mobileNo = params.mobileNo;

  const [isLoading, setisLoading] = useState(false);
  const [isGuestLoading, setIsGuestLoading] = useState(false);

  const [isOtpMode, setIsOtpMode] = useState(false);
  const [otpStep, setOtpStep] = useState(1);
  const [otpMobileNo, setOtpMobileNo] = useState("");
  const [otpValue, setOtpValue] = useState("");

  const { globalContext, dispatch } = useContext(GlobalContext);

  const handleGuestLogin = (e) => {
    e.preventDefault();
    setIsGuestLoading(true);
    Instance.post("/auth/guest/", { mobileNo })
      .then((res) => {
        if (res.status == 200) {
          if (res.data.role == "user") {
            setIsGuestLoading(false);
            dispatch({
              payload: res.data.token,
              type: SIGN_IN,
            });
            // window.location.reload();
            localStorage.setItem("user", res.data.token);
            history.push(`/${mobileNo}`);
          } else {
            setisLoading(false);
            setIsGuestLoading(false);
            dispatch({
              type: SHOW_SNACKBAR,
              payload: {
                message: "Your are not authenticate to this area.",
                type: "error",
              },
            });
          }
        }
      })
      .catch((e) => {
        setisLoading(false);
        setIsGuestLoading(false);
        dispatch({
          type: SHOW_SNACKBAR,
          payload: {
            message: e.response.data.message || "Something went wrong",
            type: "error",
          },
        });
      });
  };

  const location = useLocation();
  function getQueryVariable(variable) {
    var query = location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (decodeURIComponent(pair[0]) == variable) {
        return decodeURIComponent(pair[1]);
      }
    }
  }

  const handleSendOtp = (e) => {
    e.preventDefault();
    if (otpMobileNo === "") {
      dispatch({
        type: SHOW_SNACKBAR,
        payload: { message: "Please enter your mobile number", type: "error" },
      });
      return;
    }
    setisLoading(true);
    Instance.post("/auth/send-otp", {
      mobileNo: params.mobileNo,
      userName: otpMobileNo,
    })
      .then((res) => {
        setisLoading(false);
        setOtpStep(2);
        dispatch({
          type: SHOW_SNACKBAR,
          payload: {
            message: res.data.message || "OTP Sent Successfully",
            type: "success",
          },
        });
      })
      .catch((err) => {
        setisLoading(false);
        dispatch({
          type: SHOW_SNACKBAR,
          payload: {
            message: err.response?.data?.message || "Something went wrong",
            type: "error",
          },
        });
      });
  };

  const handleVerifyOtp = (e) => {
    e.preventDefault();
    if (otpValue === "") {
      dispatch({
        type: SHOW_SNACKBAR,
        payload: { message: "Please enter the OTP", type: "error" },
      });
      return;
    }
    setisLoading(true);
    Instance.post("/auth/verify-otp", {
      mobileNo: params.mobileNo,
      userName: otpMobileNo,
      otp: otpValue,
      uniqueNo: localStorage.getItem("unique_no"),
      modelName: "Google Chrome",
      deviceName: "Web Browser",
    })
      .then((res) => {
        setisLoading(false);
        if (res.status == 200) {
          if (res.data.role == "owner") {
            dispatch({ payload: res.data.token, type: SIGN_IN });
            localStorage.setItem("user", res.data.token);
            if (
              getQueryVariable("continue") &&
              getQueryVariable("continue").split("/")[2] == "owner"
            ) {
              history.push(getQueryVariable("continue"));
            } else {
              history.push(`/${mobileNo}/owner`);
            }
          } else if (res.data.role == "user" || res.data.role == "salesman") {
            if (res.data.uniqueNo)
              localStorage.setItem("unique_no", res.data.uniqueNo);
            if (res.data.isVerified === false) {
              dispatch({
                type: SHOW_SNACKBAR,
                payload: {
                  message:
                    "Your account is not Verified. Please Contact the Admin.",
                  type: "error",
                },
              });
            } else {
              dispatch({ payload: res.data.token, type: SIGN_IN });
              localStorage.setItem("user", res.data.token);
              if (
                getQueryVariable("continue") &&
                getQueryVariable("continue").split("/")[2] != "owner"
              ) {
                history.push(getQueryVariable("continue"));
              } else {
                history.push(`/${mobileNo}`);
              }
            }
          } else {
            dispatch({
              type: SHOW_SNACKBAR,
              payload: {
                message: "Your are not authenticate to this area.",
                type: "error",
              },
            });
          }
        }
      })
      .catch((err) => {
        setisLoading(false);
        dispatch({
          type: SHOW_SNACKBAR,
          payload: {
            message: err.response?.data?.message || "Invalid OTP",
            type: "error",
          },
        });
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setisLoading(true);
    if (userName !== "") {
      if (password !== "") {
        Instance.post("/auth/", { userName, password, mobileNo })
          .then((res) => {
            if (res.status == 200) {
              if (res.data.role == "owner") {
                dispatch({
                  payload: res.data.token,
                  type: SIGN_IN,
                });
                localStorage.setItem("user", res.data.token);
                if (
                  getQueryVariable("continue") &&
                  getQueryVariable("continue").split("/")[2] == "owner"
                ) {
                  history.push(getQueryVariable("continue"));
                  // window.location.reload();
                } else {
                  history.push(`/${mobileNo}/owner`);
                  // window.location.reload();
                }
              } else if (res.data.role == "user") {
                dispatch({
                  payload: res.data.token,
                  type: SIGN_IN,
                });
                localStorage.setItem("user", res.data.token);
                if (
                  getQueryVariable("continue") &&
                  getQueryVariable("continue").split("/")[2] != "owner"
                ) {
                  history.push(getQueryVariable("continue"));
                  // window.location.reload();
                } else {
                  history.push(`/${mobileNo}`);
                  // window.location.reload();
                }
              } else {
                setisLoading(false);
                dispatch({
                  type: SHOW_SNACKBAR,
                  payload: {
                    message: "Your are not authenticate to this area.",
                    type: "error",
                  },
                });
              }
            }
          })
          .catch((e) => {
            setisLoading(false);
            dispatch({
              type: SHOW_SNACKBAR,
              payload: {
                message: e.response.data.message || "Something went wrong",
                type: "error",
              },
            });
          });
      } else {
        setisLoading(false);
        setIsPasswordValid(false);
        setIsUserNameValid(true);
      }
    } else {
      setisLoading(false);
      setIsUserNameValid(false);
      setIsPasswordValid(true);
    }
  };

  return (
    <div>
      {["bottom"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            disableElevation
            className="mb-2 w-full"
            onClick={toggleDrawer(anchor, true)}
            style={{ marginTop: "38px" }}
            disabled={isLoading}
          >
            {isLoading ? (
              <CircularProgress size={24} color="secondary" />
            ) : (
              "Login"
            )}
          </Button>
          {globalContext.settings.length != 0 && globalContext.settings ? (
            globalContext.settings.filter(
              (e) => e.SETTING_NAME == "SHOW_SIGN_UP",
            ).length != 0 ? (
              globalContext.settings.filter(
                (e) => e.SETTING_NAME == "SHOW_SIGN_UP",
              )[0].VALUE == "Y" ? (
                <Button
                  variant="outlined"
                  color="primary"
                  type="submit"
                  disableElevation
                  className="mb-2 w-full"
                  onClick={() => {
                    history.push(`/${params.mobileNo}/signup`);
                  }}
                  style={{ marginTop: "10px" }}
                >
                  Sign Up
                </Button>
              ) : null
            ) : null
          ) : null}
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            PaperProps={{
              elevation: 0,
              style: {
                borderTopLeftRadius: "15px",
                borderTopRightRadius: "15px",
              },
            }}
          >
            <p className="uppercase pt-6 text-3xl font-bold sm:text-left pl-6">
              {isOtpMode ? "OTP Login" : "Sign In"}
            </p>
            <p className="sm:text-left pl-6">
              {isOtpMode
                ? "Login via WhatsApp OTP."
                : "Welcome back! Login into your account."}
            </p>
            <form className="p-3">
              {isOtpMode ? (
                <>
                  {otpStep === 1 && (
                    <div className="form-group pb-4">
                      <div className="font-bold text-black mb-1 text-sm">
                        Mobile Number*
                      </div>
                      <Input
                        type="text"
                        className="bg-white border rounded-2xl w-full px-2 py-2"
                        value={otpMobileNo}
                        onChange={(e) => setOtpMobileNo(e.target.value)}
                        disableUnderline
                        startAdornment={
                          <InputAdornment>
                            <PermIdentityOutlinedIcon />
                          </InputAdornment>
                        }
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        disableElevation
                        className="mt-4 w-full"
                        onClick={handleSendOtp}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <CircularProgress size={24} />
                        ) : (
                          "Send OTP"
                        )}
                      </Button>
                    </div>
                  )}

                  {otpStep === 2 && (
                    <div className="form-group pb-4">
                      <div className="font-bold text-black mb-1 text-sm">
                        Enter OTP*
                      </div>
                      <Input
                        type="text"
                        className="bg-white border rounded-2xl w-full px-2 py-2"
                        value={otpValue}
                        onChange={(e) => setOtpValue(e.target.value)}
                        disableUnderline
                        startAdornment={
                          <InputAdornment>
                            <LockOutlinedIcon />
                          </InputAdornment>
                        }
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        disableElevation
                        className="mt-4 w-full"
                        onClick={handleVerifyOtp}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <CircularProgress size={24} />
                        ) : (
                          "Verify OTP"
                        )}
                      </Button>
                    </div>
                  )}

                  <div
                    className="text-center mt-2 cursor-pointer text-xs"
                    onClick={() => setIsOtpMode(false)}
                  >
                    Back to Password Login
                  </div>
                </>
              ) : (
                <>
                  <div className="form-group">
                    <div className="font-bold text-black mb-1 text-sm">
                      Phone or Acc Cd*
                    </div>
                    <Input
                      type="text"
                      className="bg-white border rounded-2xl w-full px-2 py-2"
                      value={userName}
                      onChange={(e) => setUserName(e.target.value)}
                      disableUnderline
                      startAdornment={
                        <InputAdornment>
                          <PermIdentityOutlinedIcon />
                        </InputAdornment>
                      }
                    />
                    {!isUserNameValid ? (
                      <div className="text-red-500 mt-1">
                        Please Enter valid Phone or Acc Cd.
                      </div>
                    ) : null}
                  </div>

                  <div className="form-group">
                    <div className="font-bold text-black mb-1 text-sm">
                      Password*
                    </div>
                    <Input
                      type={isPasswordVisible ? "text" : "password"}
                      className="bg-white border rounded-2xl w-full px-2 py-2"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      disableUnderline
                      startAdornment={
                        <InputAdornment>
                          <LockOutlinedIcon />
                        </InputAdornment>
                      }
                      endAdornment={
                        <div
                          onClick={() => {
                            setIsPasswordVisible(!isPasswordVisible);
                          }}
                          className="cursor-pointer"
                        >
                          <InputAdornment>
                            {isPasswordVisible ? (
                              <VisibilityOutlinedIcon />
                            ) : (
                              <VisibilityOffOutlinedIcon />
                            )}
                          </InputAdornment>
                        </div>
                      }
                    />
                    {!isPasswordValid ? (
                      <div className="text-red-500 mt-1">
                        Please Enter valid Password.
                      </div>
                    ) : null}
                  </div>

                  <div className="form-group">
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      disableElevation
                      className="mb-2 w-full"
                      onClick={handleSubmit}
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <CircularProgress size={24} color="secondary" />
                      ) : (
                        "Login"
                      )}
                    </Button>
                  </div>
                  {globalContext.settings.length != 0 &&
                  globalContext.settings ? (
                    globalContext.settings.filter(
                      (e) => e.SETTING_NAME == "GUEST_LOGIN",
                    )[0].VALUE == "Y" ? (
                      <Button
                        variant="outlined"
                        color="primary"
                        type="submit"
                        disableElevation
                        className="mb-2 w-full"
                        onClick={handleGuestLogin}
                        disabled={isGuestLoading}
                      >
                        {isGuestLoading ? (
                          <CircularProgress size={24} color="secondary" />
                        ) : (
                          "Login as Guest"
                        )}
                      </Button>
                    ) : null
                  ) : null}
                  {globalContext.settings.length != 0 &&
                  globalContext.settings ? (
                    globalContext.settings.filter(
                      (e) => e.SETTING_NAME == "LOGIN_WITH_OTP_HUB360",
                    ).length != 0 ? (
                      globalContext.settings.filter(
                        (e) => e.SETTING_NAME == "LOGIN_WITH_OTP_HUB360",
                      )[0].VALUE == "Y" ? (
                        <Button
                          variant="outlined"
                          color="default"
                          type="button"
                          disableElevation
                          className="mb-2 w-full"
                          onClick={() => setIsOtpMode(true)}
                          disabled={isLoading || isGuestLoading}
                        >
                          Login with OTP
                        </Button>
                      ) : null
                    ) : null
                  ) : null}
                </>
              )}
            </form>
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
